import { Injectable, signal } from '@angular/core'
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker'
import { filter, interval } from 'rxjs'
import { environment } from 'src/environments/environment'

@Injectable({ providedIn: 'root' })
export class VersionCheckService {

    readonly updateAvailable = signal(false)

    constructor(private swUpdate: SwUpdate) {
        if (!this.swUpdate.isEnabled) {
            console.log('[VersionCheck] Service worker not enabled')
            return
        }

        console.log(`[VersionCheck] Active — polling every ${environment.updateCheckInterval / 1000}s`)

        // Listen for version-ready events
        this.swUpdate.versionUpdates.pipe(
            filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY')
        ).subscribe(event => {
            console.log('[VersionCheck] Update available:', event.currentVersion.hash, '->', event.latestVersion.hash)
            this.updateAvailable.set(true)
        })

        // Poll for updates at the configured interval
        interval(environment.updateCheckInterval).subscribe(() => {
            this.swUpdate.checkForUpdate().catch(err => {
                console.warn('[VersionCheck] Check failed:', err)
            })
        })
    }

    reloadApp(): void {
        document.location.reload()
    }
}
